import React from "react";
import { companyInfo } from "../CompanyInfo/CompanyInfo";
import { Link } from "react-router-dom";
import logo from "../pages/assets/eduit-logo.png";

const MailIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.6 19.79 19.79 0 0 1 1.57 5.08 2 2 0 0 1 3.55 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.08a16 16 0 0 0 6.02 6.02l.65-.78a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ArrowRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);

const Footer = () => {
  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Our Team", path: "/team" },
    { label: "Testimonials", path: "/testimonials" },
    { label: "Contact", path: "/contact" },
    { label: "Privacy Policy", path: "/privacy-policy" },
  ];

  const itServices = [
    { label: "Web Development", path: "/services/web-development" },
    { label: "App Development", path: "/services/app-development" },
    { label: "Social Media Marketing", path: "/services/social-media-marketing" },
  ];

  const hrServices = [
    { label: "Executive Recruitment", path: "/services/recruitment-services" },
    { label: "Entry & Mid-Level Hiring", path: "/services/entry-middle-level-hiring" },
    { label: "Third Party Payroll", path: "/services/payroll-services" },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          {/* COMPANY */}
          <div>
            <Link to="/" onClick={() => window.scrollTo(0, 0)} className="footer-logo">
              <img src={logo} alt="EduITalent Logo" style={{ height: "48px", width: "auto", objectFit: "contain" }} />
            </Link>
            <p className="footer-text">
              Your trusted partner for IT services and strategic recruitment.
              Offices in Noida, India and Globe — serving clients globally.
            </p>
            <div className="footer-social-row">
              <a href="https://www.linkedin.com/company/eduitalent-company/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="LinkedIn">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
              </a>
              <a href="https://www.facebook.com/share/1HBhi31rYg/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Facebook">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
              </a>
              <a href="https://www.instagram.com/eduitalent?igsh=MWs3eHh6azhtbTZrNA==" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Instagram">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h4 className="footer-heading">Quick Links</h4>
            <ul>
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="footer-nav-link">
                    <ArrowRight /> {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* SERVICES */}
          <div>
            <h4 className="footer-heading">IT Services</h4>
            <ul style={{ marginBottom: "24px" }}>
              {itServices.map((s) => (
                <li key={s.path}>
                  <Link to={s.path} onClick={() => window.scrollTo(0, 0)} className="footer-nav-link">
                    <ArrowRight /> {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="footer-heading">Recruitment</h4>
            <ul>
              {hrServices.map((s) => (
                <li key={s.path}>
                  <Link to={s.path} onClick={() => window.scrollTo(0, 0)} className="footer-nav-link">
                    <ArrowRight /> {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="contact-list footer-contact-list">
              {companyInfo.email && (
                <li className="footer-contact-item">
                  <span className="footer-contact-icon"><MailIcon /></span>
                  <a href={`mailto:${companyInfo.email}`} className="footer-contact-link">{companyInfo.email}</a>
                </li>
              )}
              {companyInfo.phone && (
                <li className="footer-contact-item">
                  <span className="footer-contact-icon"><PhoneIcon /></span>
                  <div>
                    <div className="footer-contact-sub">India</div>
                    <a href={`tel:${companyInfo.phone}`} className="footer-contact-link">{companyInfo.phone}</a>
                  </div>
                </li>
              )}
              {companyInfo.phone2 && (
                <li className="footer-contact-item">
                  <span className="footer-contact-icon"><PhoneIcon /></span>
                  <div>
                    <div className="footer-contact-sub">Globe</div>
                    <a href={`tel:${companyInfo.phone2}`} className="footer-contact-link">{companyInfo.phone2}</a>
                  </div>
                </li>
              )}
              {companyInfo.address && (
                <li className="footer-contact-item" style={{ alignItems: "flex-start" }}>
                  <span className="footer-contact-icon" style={{ marginTop: "2px" }}><MapPinIcon /></span>
                  <div>
                    <div className="footer-contact-sub">India Office</div>
                    <span className="footer-contact-link" style={{ cursor: "default" }}>{companyInfo.address}</span>
                  </div>
                </li>
              )}
              {companyInfo.address2 && (
                <li className="footer-contact-item" style={{ alignItems: "flex-start" }}>
                  <span className="footer-contact-icon" style={{ marginTop: "2px" }}><MapPinIcon /></span>
                  <div>
                    <div className="footer-contact-sub">Globe Office</div>
                    <span className="footer-contact-link" style={{ cursor: "default" }}>{companyInfo.address2}</span>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {companyInfo.name}. All rights reserved. &nbsp;|&nbsp; IT Services &amp; Recruitment Excellence &nbsp;|&nbsp; <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)} className="footer-bottom-link">Privacy Policy</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
